<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->

    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>New Academic year Session Date</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-row justify="center" dense>
        <v-col cols="12" sm="3" md="3">
          <p><v-icon color="error">*</v-icon>&nbsp;<b>Academic Year</b></p>
          <v-autocomplete @change="getSessionDate" color="#0F2027" dense rounded required v-model="ay" :items="ay_list"
            item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint
            hint="Please Select Academic Year" />
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <p><v-icon color="error">*</v-icon>&nbsp;<b>Standard</b></p>
          <v-autocomplete color="#0F2027" dense rounded required v-model="standard" :items="standard_list"
            item-text="standard" item-value="standard_id" label="Standard" multiple outlined persistent-hint
            hint="Please Select Standard" />
        </v-col>
        <v-col cols="12" sm="3" md="3">
          <p><v-icon color="error">*</v-icon>&nbsp;<b>Session Date</b></p>
          <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <!-- <v-icon color="error">*</v-icon><v-text-field rounded outlined dense  @blur="date = parseDate(date)" hint="YYYY/MM/DD format" persistent-hint v-model="date" label="Date Of Open House" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field> -->
              <v-icon color="error"></v-icon>
              <v-text-field rounded outlined dense hint="YYYY/MM/DD format" persistent-hint v-model="date" label="Date"
                prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row justify="center" dense>
        <v-btn class="button" v-if="ay && standard != ''" @click="save()" :loading="loader">Save</v-btn>
      </v-row>
    </v-card>
    <v-card class="box" v-if="session_list != ''">
      <v-data-table :headers="headers" class="elevation-1 mytable" dense :items="session_list">
        <template v-slot:[`item.edit`]="{ item }">
          <v-avatar size="25" class="edit-avatar ml-5">
            <v-icon class="mr-2 edit-v-icon" @click="changeDate(item)" title="edit">edit</v-icon>
          </v-avatar>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialog" max-width="800px">
      <v-card>
        <v-col cols="12" sm="12" md="12">
          <v-card class="box">
            <v-row justify="center" dense>
              <v-col cols="12" sm="6" md="6">
                <p><b>Update Session Date</b></p>
                <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                  offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field hint="YYYY/MM/DD format" persistent-hint v-model="date_edit"
                      label="Picker without buttons" prepend-icon="mdi-calendar" readonly v-bind="attrs"
                      v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="date_edit" @input="menu = false"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row justify="center" dense>
              <v-btn class="button" @click="editSessionDate()" :loading="loader">Update</v-btn>
              <v-btn class="button" @click="dialog = false">Close</v-btn>
            </v-row>
          </v-card>
        </v-col>
      </v-card>
    </v-dialog>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    delete_attach_load: false,
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    // extraBreadcrumbItems: [
    

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    ay_list: [],
    ay: "",
    standard_list: [],
    standard: [],
    open_house_list: [],
    semester_list: [],
    semester: "",
    sem: null,
    title: "",
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    //  date_edit_marksheet: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
    date_edit: null,
    menu1: false,
    modal1: false,
    modal2: false,
    edit_id: "",
    menu: false,
    modal: false,
    menu2: false,
    checkbox: false,
    dialog: false,
    session_list: [],
    headers: [
      { text: "Academic Year", value: "academicyear" },
      { text: "Standard", value: "standard" },
      { text: "Session Date", value: "date" },
      { text: "Edit", value: "edit" },
    ],
  }),
  methods: {
    changeDate(item) {
      this.dialog = true;
      (this.date_edit = item.sessiondate_edit), (this.edit_id = item.id);
      //alert(this.date_edit)
    },
    getSessionDate() {
      const data = {
        ay: this.ay,
      };
      axios
        .post("/Examination/getSessionDate", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.session_list = res.data.session_list;
          }
        })
        .catch((error) => {
          window.console.log(error);
          this.showSnackbar("#b71c1c", "Something went wrong!");
        })
        .finally(() => {});
    },
    // parseDate(date) {
    //     if (!date) return null;
    //     const [month, day, year] = date.split("/");
    //     return `${year}/${month.padStart(2, "0")}/${day.padStart(2, "0")}`;
    // },
    save() {
      const data = {
        session_date: this.date,
        ay: this.ay,
        standard: this.standard,
      };
      axios
        .post("/Examination/saveSessionDate", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("#4caf50", "Saved Successfully...");
            this.getSessionDate();
          }
        })
        .catch((error) => {
          window.console.log(error);
          this.showSnackbar("#b71c1c", "Something went wrong!");
        })
        .finally(() => {
          this.standard = [];
        });
    },
    editSessionDate() {
      const data = {
        id: this.edit_id,
        session_date: this.date_edit,
      };
      axios
        .post("/Examination/editSessionDate", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("#4caf50", "Updated Successfully...");
            this.dialog = false;
            this.getSessionDate();
          }
        })
        .catch((error) => {
          window.console.log(error);
          this.showSnackbar("#b71c1c", "Something went wrong!");
        })
        .finally(() => {});
    },
    onLoad() {
      axios
        .post("/Examination/openHouse")
        .then((res) => {
          if (res.data.flag == "Yes") {
            (this.ay_list = res.data.ay_list),
              (this.standard_list = res.data.standard_list),
              (this.open_house_list = res.data.open_house_list);
            this.semester_list = res.data.semester_list;
          } else {
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {});
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
.mytable2 /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>
